/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ImportType = {
    Companies: 'Companies',
    BusinessUnits: 'BusinessUnits',
    Categories: 'Categories',
    Orders: 'Orders',
    Invoices: 'Invoices'
} as const;
export type ImportType = typeof ImportType[keyof typeof ImportType];


export function instanceOfImportType(value: any): boolean {
    for (const key in ImportType) {
        if (Object.prototype.hasOwnProperty.call(ImportType, key)) {
            if (ImportType[key as keyof typeof ImportType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ImportTypeFromJSON(json: any): ImportType {
    return ImportTypeFromJSONTyped(json, false);
}

export function ImportTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImportType {
    return json as ImportType;
}

export function ImportTypeToJSON(value?: ImportType | null): any {
    return value as any;
}

export function ImportTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): ImportType {
    return value as ImportType;
}

